export interface SelectedUser {
  id: string;
  desktopAccess: boolean;
}

export type BulkAccessOutcome = 'applied' | 'skipped' | 'failed';

export function planBulkAccess(
  selected: ReadonlyMap<string, SelectedUser>,
  target: boolean
): { apply: string[]; skip: string[] } {
  const apply: string[] = [];
  const skip: string[] = [];
  for (const user of selected.values()) {
    (user.desktopAccess === target ? skip : apply).push(user.id);
  }
  return { apply, skip };
}

export function summarizeBulkAccess(
  outcomes: readonly BulkAccessOutcome[]
): { applied: number; skipped: number; failed: number } {
  return outcomes.reduce(
    (summary, outcome) => {
      if (outcome === 'applied') summary.applied += 1;
      else if (outcome === 'skipped') summary.skipped += 1;
      else summary.failed += 1;
      return summary;
    },
    { applied: 0, skipped: 0, failed: 0 }
  );
}

export function togglePageSelection(
  selected: ReadonlyMap<string, SelectedUser>,
  pageRows: readonly SelectedUser[],
  checked: boolean
): Map<string, SelectedUser> {
  const next = new Map(selected);
  for (const user of pageRows) {
    if (checked) next.set(user.id, user);
    else next.delete(user.id);
  }
  return next;
}
